define("shared/components/shared/profile-categorization/categorize-steps", ["exports", "@ember/component", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "lodash", "later/utils/array-methods", "later/utils/object-methods", "shared/utils/profile-categorization-values", "shared/utils/search", "@ember/template-factory"], function (_exports, _component, _object, _service, _utils, _component2, _tracking, _lodash, _arrayMethods, _objectMethods, _profileCategorizationValues, _search, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"lodash",0,"later/utils/array-methods",0,"later/utils/object-methods",0,"shared/utils/profile-categorization-values",0,"shared/utils/search",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div {{did-insert this.addKeyupListener}} {{on "click" this.handleClick}} {{will-destroy this.removeKeyupListener}}>
    <Shared::ProfileCategorization::CategorizeSteps::ProgressBar
      @progressValue={{this.progressValue}}
      @socialProfile={{@socialProfile}}
    />
  
    <Shared::ProfileCategorization::Icons />
  
    {{#if (not this.isCategoryStepComplete)}}
      <p class="u--m__b__md u--text--light u--text--center">
        {{t
          "profile_categorization.categorize_form.tell_us_about_profile"
          displayNickname=@socialProfile.displayNickname
        }}
      </p>
      <h2 class="tSC--card__title at--onboardingSelfCat__cardTitle">
        {{t
          "profile_categorization.categorize_form.what_category_are_you"
          displayNickname=@socialProfile.displayNickname
        }}
      </h2>
  
      <ul class="tSC--grid">
        {{#each this.formattedCategories as |category|}}
          <li class="tSC--grid__item qa--categorize_category" onclick={{action "chooseCategory" category.categoryId}}>
            <svg class="tSC--grid__icon">
              <use xlink:href="#{{category.categoryIconClass}}"></use>
            </svg>
            <p class="tSC--grid__title">{{category.name}}</p>
          </li>
        {{/each}}
      </ul>
    {{else if (not this.isIndustryStepComplete)}}
      <p class="u--m__b__0 u--text--light u--text--center qa--categorize_title">
        {{t
          "profile_categorization.categorize_form.tell_us_about_profile"
          displayNickname=@socialProfile.displayNickname
        }}
      </p>
      <p class="u--text--light u--text--center">
        {{t "profile_categorization.categorize_form.category"}}
        {{this.selectedCategory.name}}
      </p>
  
      <Shared::ProfileCategorization::CategorizeSteps::Industry
        @chooseIndustry={{this.chooseIndustry}}
        @clearSelectedCategory={{this.clearSelectedCategory}}
        @displayNickname={{@socialProfile.displayNickname}}
        @formattedIndustries={{this.formattedIndustries}}
        @otherIndustry={{this.otherIndustry}}
        @otherIndustrySearchResults={{this.otherIndustrySearchResults}}
        @otherIndustrySelected={{this.otherIndustrySelected}}
        @searchOtherIndustry={{this.searchOtherIndustry}}
        @selectedCategory={{this.selectedCategory}}
        @selectedIndustry={{this.selectedIndustry}}
        @setCloseAction={{fn this.setCloseAction "industry"}}
        @setOpenAction={{fn this.setOpenAction "industry"}}
      />
  
    {{else if (not this.isBusinessModelStepComplete)}}
      <Shared::ProfileCategorization::CategorizeSteps::BusinessModel
        @businessModelQuestions={{this.businessModelQuestions}}
        @businessTypes={{this.businessTypes}}
        @chooseBusinessModel={{this.chooseBusinessModel}}
        @chooseBusinessType={{this.chooseBusinessType}}
        @clearSelectedIndustry={{this.clearSelectedIndustry}}
        @displayNickname={{@socialProfile.displayNickname}}
        @finalBusinessModels={{this.finalBusinessModels}}
        @isBusinessModelFormComplete={{this.isBusinessModelFormComplete}}
        @isBusinessTypeStepComplete={{this.isBusinessTypeStepComplete}}
        @markBusinessModelSelectionComplete={{this.markBusinessModelSelectionComplete}}
        @otherBusinessModel={{this.otherBusinessModel}}
        @otherBusinessModelSearchResults={{this.otherBusinessModelSearchResults}}
        @otherBusinessModelSelected={{this.otherBusinessModelSelected}}
        @removeBusinessModels={{this.removeBusinessModels}}
        @searchOtherBusinessModel={{this.searchOtherBusinessModel}}
        @selectedBusinessModel={{this.selectedBusinessModel}}
        @selectedBusinessType={{this.selectedBusinessType}}
        @selectedCategory={{this.selectedCategory}}
        @setCloseAction={{fn this.setCloseAction "business"}}
        @setOpenAction={{fn this.setOpenAction "business"}}
        @trackRedidCategorization={{fn this.trackRedidCategorization "bus_type"}}
        @undoLastRemovedBusinessModels={{this.undoLastRemovedBusinessModels}}
        @validQuestions={{this.validQuestions}}
      />
    {{/if}}
  </div>
  */
  {
    "id": "XedvDiHK",
    "block": "[[[11,0],[4,[38,0],[[30,0,[\"addKeyupListener\"]]],null],[4,[38,1],[\"click\",[30,0,[\"handleClick\"]]],null],[4,[38,2],[[30,0,[\"removeKeyupListener\"]]],null],[12],[1,\"\\n  \"],[8,[39,3],null,[[\"@progressValue\",\"@socialProfile\"],[[30,0,[\"progressValue\"]],[30,1]]],null],[1,\"\\n\\n  \"],[8,[39,4],null,null,null],[1,\"\\n\\n\"],[41,[28,[37,6],[[30,0,[\"isCategoryStepComplete\"]]],null],[[[1,\"    \"],[10,2],[14,0,\"u--m__b__md u--text--light u--text--center\"],[12],[1,\"\\n      \"],[1,[28,[35,7],[\"profile_categorization.categorize_form.tell_us_about_profile\"],[[\"displayNickname\"],[[30,1,[\"displayNickname\"]]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"h2\"],[14,0,\"tSC--card__title at--onboardingSelfCat__cardTitle\"],[12],[1,\"\\n      \"],[1,[28,[35,7],[\"profile_categorization.categorize_form.what_category_are_you\"],[[\"displayNickname\"],[[30,1,[\"displayNickname\"]]]]]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,\"ul\"],[14,0,\"tSC--grid\"],[12],[1,\"\\n\"],[42,[28,[37,9],[[28,[37,9],[[30,0,[\"formattedCategories\"]]],null]],null],null,[[[1,\"        \"],[10,\"li\"],[14,0,\"tSC--grid__item qa--categorize_category\"],[15,\"onclick\",[28,[37,10],[[30,0],\"chooseCategory\",[30,2,[\"categoryId\"]]],null]],[12],[1,\"\\n          \"],[10,\"svg\"],[14,0,\"tSC--grid__icon\"],[12],[1,\"\\n            \"],[10,\"use\"],[15,\"xlink:href\",[29,[\"#\",[30,2,[\"categoryIconClass\"]]]],\"http://www.w3.org/1999/xlink\"],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[14,0,\"tSC--grid__title\"],[12],[1,[30,2,[\"name\"]]],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[2]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,6],[[30,0,[\"isIndustryStepComplete\"]]],null],[[[1,\"    \"],[10,2],[14,0,\"u--m__b__0 u--text--light u--text--center qa--categorize_title\"],[12],[1,\"\\n      \"],[1,[28,[35,7],[\"profile_categorization.categorize_form.tell_us_about_profile\"],[[\"displayNickname\"],[[30,1,[\"displayNickname\"]]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--text--light u--text--center\"],[12],[1,\"\\n      \"],[1,[28,[35,7],[\"profile_categorization.categorize_form.category\"],null]],[1,\"\\n      \"],[1,[30,0,[\"selectedCategory\",\"name\"]]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[8,[39,11],null,[[\"@chooseIndustry\",\"@clearSelectedCategory\",\"@displayNickname\",\"@formattedIndustries\",\"@otherIndustry\",\"@otherIndustrySearchResults\",\"@otherIndustrySelected\",\"@searchOtherIndustry\",\"@selectedCategory\",\"@selectedIndustry\",\"@setCloseAction\",\"@setOpenAction\"],[[30,0,[\"chooseIndustry\"]],[30,0,[\"clearSelectedCategory\"]],[30,1,[\"displayNickname\"]],[30,0,[\"formattedIndustries\"]],[30,0,[\"otherIndustry\"]],[30,0,[\"otherIndustrySearchResults\"]],[30,0,[\"otherIndustrySelected\"]],[30,0,[\"searchOtherIndustry\"]],[30,0,[\"selectedCategory\"]],[30,0,[\"selectedIndustry\"]],[28,[37,12],[[30,0,[\"setCloseAction\"]],\"industry\"],null],[28,[37,12],[[30,0,[\"setOpenAction\"]],\"industry\"],null]]],null],[1,\"\\n\\n\"]],[]],[[[41,[28,[37,6],[[30,0,[\"isBusinessModelStepComplete\"]]],null],[[[1,\"    \"],[8,[39,13],null,[[\"@businessModelQuestions\",\"@businessTypes\",\"@chooseBusinessModel\",\"@chooseBusinessType\",\"@clearSelectedIndustry\",\"@displayNickname\",\"@finalBusinessModels\",\"@isBusinessModelFormComplete\",\"@isBusinessTypeStepComplete\",\"@markBusinessModelSelectionComplete\",\"@otherBusinessModel\",\"@otherBusinessModelSearchResults\",\"@otherBusinessModelSelected\",\"@removeBusinessModels\",\"@searchOtherBusinessModel\",\"@selectedBusinessModel\",\"@selectedBusinessType\",\"@selectedCategory\",\"@setCloseAction\",\"@setOpenAction\",\"@trackRedidCategorization\",\"@undoLastRemovedBusinessModels\",\"@validQuestions\"],[[30,0,[\"businessModelQuestions\"]],[30,0,[\"businessTypes\"]],[30,0,[\"chooseBusinessModel\"]],[30,0,[\"chooseBusinessType\"]],[30,0,[\"clearSelectedIndustry\"]],[30,1,[\"displayNickname\"]],[30,0,[\"finalBusinessModels\"]],[30,0,[\"isBusinessModelFormComplete\"]],[30,0,[\"isBusinessTypeStepComplete\"]],[30,0,[\"markBusinessModelSelectionComplete\"]],[30,0,[\"otherBusinessModel\"]],[30,0,[\"otherBusinessModelSearchResults\"]],[30,0,[\"otherBusinessModelSelected\"]],[30,0,[\"removeBusinessModels\"]],[30,0,[\"searchOtherBusinessModel\"]],[30,0,[\"selectedBusinessModel\"]],[30,0,[\"selectedBusinessType\"]],[30,0,[\"selectedCategory\"]],[28,[37,12],[[30,0,[\"setCloseAction\"]],\"business\"],null],[28,[37,12],[[30,0,[\"setOpenAction\"]],\"business\"],null],[28,[37,12],[[30,0,[\"trackRedidCategorization\"]],\"bus_type\"],null],[30,0,[\"undoLastRemovedBusinessModels\"]],[30,0,[\"validQuestions\"]]]],null],[1,\"\\n  \"]],[]],null]],[]]]],[]]],[13]],[\"@socialProfile\",\"category\"],false,[\"did-insert\",\"on\",\"will-destroy\",\"shared/profile-categorization/categorize-steps/progress-bar\",\"shared/profile-categorization/icons\",\"if\",\"not\",\"t\",\"each\",\"-track-array\",\"action\",\"shared/profile-categorization/categorize-steps/industry\",\"fn\",\"shared/profile-categorization/categorize-steps/business-model\"]]",
    "moduleName": "shared/components/shared/profile-categorization/categorize-steps.hbs",
    "isStrictMode": false
  });
  const RETURN_KEY = 13;
  const TAB_KEY = 9;
  let CategorizeStepsComponent = _exports.default = (_class = class CategorizeStepsComponent extends _component2.default {
    closeEmberDropActionIndustry() {}
    openEmberDropActionIndustry() {}
    closeEmberDropActionBusiness() {}
    openEmberDropActionBusiness() {}
    get socialProfile() {
      return this.auth.currentSocialProfile;
    }
    get businessModels() {
      return this.selectedBusinessType?.businessModels;
    }
    get businessModelQuestions() {
      return this.selectedBusinessType?.questions;
    }
    get otherIndustrySelected() {
      return this.selectedIndustry?.value === 'other';
    }
    get otherBusinessModelSelected() {
      return this.selectedBusinessModel?.value === 'other';
    }
    get progressValue() {
      const stepsToComplete = [this.isCategoryStepComplete, this.isIndustryStepComplete, this.isBusinessTypeStepComplete, this.isBusinessModelStepComplete];
      const isOnBusinessModelStep = this.isBusinessTypeStepComplete && this.validQuestions?.length === 0;
      const maxExtraQuestions = 3;
      const numExtraQuestions = this.validQuestions?.length || maxExtraQuestions;
      const totalSteps = stepsToComplete.length + numExtraQuestions;
      if (isOnBusinessModelStep) {
        // Note: This is the final categorization step,
        // at which point there are no more valid questions to count
        return (totalSteps - 1) / totalSteps;
      }
      const stepsCompleted = stepsToComplete.filter(Boolean).length;
      const numOfExtraQuestionsAnswered = this.validQuestions?.filterBy('isAnswered').length || 0;
      return (stepsCompleted + numOfExtraQuestionsAnswered) / totalSteps;
    }
    get removedBusinessModels() {
      return (0, _arrayMethods.findUnique)((0, _lodash.flatten)(this.removedBusinessModelArrays));
    }
    get isIndustryFormComplete() {
      return !(0, _utils.isEmpty)(this.selectedCategory) && !(0, _utils.isEmpty)(this.selectedIndustry) && this.otherIndustryCompleted;
    }
    get isBusinessModelFormComplete() {
      return !(0, _utils.isEmpty)(this.selectedBusinessModel) && this.otherBusinessModelCompleted;
    }
    get otherIndustryCompleted() {
      if (this.otherIndustrySelected) {
        return !(0, _utils.isEmpty)(this.otherIndustry);
      }
      return true;
    }
    get otherBusinessModelCompleted() {
      if (this.otherBusinessModelSelected) {
        return !(0, _utils.isEmpty)(this.otherBusinessModel);
      }
      return true;
    }
    get formattedCategories() {
      return (0, _arrayMethods.randomizeArray)(this.categories.slice());
    }
    get formattedIndustries() {
      return this._addOtherEntry(this.selectedCategory.industries.slice());
    }
    get finalBusinessModels() {
      return this.formattedBusinessModels.filter(_ref => {
        let {
          value
        } = _ref;
        return !this.removedBusinessModels.some(removedValue => removedValue === value);
      });
    }
    get formattedBusinessModels() {
      if ((0, _utils.isEmpty)(this.businessModels)) {
        return [];
      }
      return this._addOtherEntry(this.businessModels.slice());
    }
    get flattenedIndustries() {
      return this._createObjForEachKeyword(this.industries);
    }
    get flattenedBusinessModels() {
      return this._createObjForEachKeyword(this.allBusinessModels);
    }
    get validQuestions() {
      if ((0, _lodash.isEmpty)(this.businessModelQuestions) || (0, _lodash.isEmpty)(this.finalBusinessModels)) {
        return null;
      }
      return this.businessModelQuestions.filter(_ref2 => {
        let {
          needs
        } = _ref2;
        if ((0, _lodash.isEmpty)(needs)) {
          return true;
        }
        return needs.any(neededValue => this.finalBusinessModels.findBy('value', neededValue));
      });
    }
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "auth", _descriptor3, this);
      _initializerDefineProperty(this, "segment", _descriptor4, this);
      _initializerDefineProperty(this, "errors", _descriptor5, this);
      _initializerDefineProperty(this, "isCategoryStepComplete", _descriptor6, this);
      _initializerDefineProperty(this, "isIndustryStepComplete", _descriptor7, this);
      _initializerDefineProperty(this, "isBusinessModelStepComplete", _descriptor8, this);
      _initializerDefineProperty(this, "isBusinessTypeStepComplete", _descriptor9, this);
      _initializerDefineProperty(this, "removedBusinessModelArrays", _descriptor10, this);
      _initializerDefineProperty(this, "otherIndustrySearchResults", _descriptor11, this);
      _initializerDefineProperty(this, "otherIndustry", _descriptor12, this);
      _initializerDefineProperty(this, "otherBusinessModelSearchResults", _descriptor13, this);
      _initializerDefineProperty(this, "otherBusinessModel", _descriptor14, this);
      _initializerDefineProperty(this, "selectedCategory", _descriptor15, this);
      _initializerDefineProperty(this, "selectedIndustry", _descriptor16, this);
      _initializerDefineProperty(this, "selectedBusinessModel", _descriptor17, this);
      _initializerDefineProperty(this, "selectedBusinessType", _descriptor18, this);
      this.categories = (0, _profileCategorizationValues.getCategories)(this.intl);
      this.industries = (0, _profileCategorizationValues.getIndustries)(this.intl, true);
      this.allBusinessModels = (0, _profileCategorizationValues.getBusinessModels)(this.intl);
      this.businessTypes = (0, _profileCategorizationValues.getBusinessTypes)(this.intl, this.args.socialProfile.get('nickname'));
      this.boundKeyHandler = this._keyHandler.bind(this);
    }
    addKeyupListener() {
      document.addEventListener('keyup', this.boundKeyHandler);
    }
    removeKeyupListener() {
      document.removeEventListener('keyup', this.boundKeyHandler);
    }
    removeBusinessModels(removedArray) {
      this.removedBusinessModelArrays = [...this.removedBusinessModelArrays, removedArray];
    }
    undoLastRemovedBusinessModels() {
      this.removedBusinessModelArrays = this.removedBusinessModelArrays.slice(0, -1);
    }
    setOpenAction(name, openAction, dropInstance) {
      if (name === 'industry') {
        this.emberDropInstanceIndustry = dropInstance;
        this.openEmberDropActionIndustry = openAction;
      } else if (name === 'business') {
        this.emberDropInstanceBusiness = dropInstance;
        this.openEmberDropActionBusiness = openAction;
      }
    }
    setCloseAction(name, closeAction, dropInstance) {
      if (name === 'industry') {
        this.emberDropInstanceIndustry = dropInstance;
        this.closeEmberDropActionIndustry = closeAction;
      } else if (name === 'business') {
        this.emberDropInstanceBusiness = dropInstance;
        this.closeEmberDropActionBusiness = closeAction;
      }
    }
    searchOtherIndustry(query) {
      this.openEmberDropActionIndustry(this.emberDropInstanceIndustry);
      this.otherIndustry = query;
      this.otherIndustrySearchResults = this._searchOther(this.otherIndustry, this.flattenedIndustries);
    }
    searchOtherBusinessModel(query) {
      this.openEmberDropActionBusiness(this.emberDropInstanceBusiness);
      this.otherBusinessModel = query;
      this.otherBusinessModelSearchResults = this._searchOther(this.otherBusinessModel, this.flattenedBusinessModels);
    }
    chooseCategory(categoryId) {
      const category = this.categories.find(category => category.categoryId === categoryId);
      if ((0, _utils.isNone)(category)) {
        return;
      }
      this.selectedCategory = category;
      this.isCategoryStepComplete = true;
    }
    chooseIndustry(industry) {
      this.selectedIndustry = !(0, _utils.isEmpty)(industry) ? industry : null;
      if (!this.otherIndustrySelected) {
        this.otherIndustry = null;
        this.otherIndustrySearchResults = null;
      }
      if (this.isIndustryFormComplete) {
        this._markIndustrySelectionComplete();
      }
    }
    chooseBusinessType(businessType) {
      this.selectedBusinessType = !(0, _utils.isEmpty)(businessType) ? businessType : null;
      this.selectedBusinessModel = null;
      this.keywordBusinessModel = null;
      if (this.otherBusinessModelSelected) {
        this.otherBusinessModel = null;
        this.otherBusinessModelSearchResults = null;
      }
      this.isBusinessTypeStepComplete = (0, _utils.isPresent)(businessType);
    }
    chooseBusinessModel(businessModel) {
      this.closeEmberDropActionBusiness(this.emberDropInstanceBusiness);
      this.selectedBusinessModel = !(0, _utils.isEmpty)(businessModel) ? businessModel : null;
      this.keywordBusinessModel = !(0, _utils.isEmpty)(businessModel) && businessModel.keyword ? businessModel.keyword : null;
      if (!this.otherBusinessModelSelected) {
        this.otherBusinessModel = null;
        this.otherBusinessModelSearchResults = null;
      }
    }
    trackRedidCategorization(page) {
      const eventName = 'redid-self-cat';
      const {
        id,
        nickname
      } = this.args.socialProfile || {};
      const user = this.auth.currentUserModel.id;
      try {
        this.segment.track(eventName, {
          area: this.args.sectionName,
          user,
          profile: id,
          page,
          social_profile_nickname: nickname
        });
      } catch (error) {
        this.errors.handleAdapter(new Error(`Error Tracking ${eventName} from location ${this.args.sectionName}`), error);
      }
    }
    clearSelectedCategory() {
      this.closeEmberDropActionIndustry(this.emberDropInstanceIndustry);
      this.closeEmberDropActionBusiness(this.emberDropInstanceBusiness);
      this.trackRedidCategorization('category');
      this._clearAllSelections();
    }
    clearSelectedIndustry() {
      this.closeEmberDropActionIndustry(this.emberDropInstanceIndustry);
      this.closeEmberDropActionBusiness(this.emberDropInstanceBusiness);
      this.trackRedidCategorization('bus_type');
      this._clearIndustrySelections();
    }
    markIndustrySelectionComplete() {
      this._markIndustrySelectionComplete();
    }
    markBusinessModelSelectionComplete(event) {
      event.preventDefault();
      this._markBusinessModelSelectionComplete();
    }
    handleClick(_ref3) {
      let {
        target
      } = _ref3;
      const industrySearchElement = document.getElementById('industry-search-box');
      if (industrySearchElement && !industrySearchElement.contains(target)) {
        this.closeEmberDropActionIndustry(this.emberDropInstanceIndustry);
      }
      const businessSearchElement = document.getElementById('business-search-box');
      if (businessSearchElement && !businessSearchElement.contains(target)) {
        this.closeEmberDropActionBusiness(this.emberDropInstanceBusiness);
      }
    }
    _clearAllSelections() {
      this.isCategoryStepComplete = null;
      this.isIndustryStepComplete = null;
      this.isBusinessModelStepComplete = null;
      this.selectedCategory = null;
      this.selectedIndustry = null;
      this.selectedBusinessModel = null;
      this.selectedBusinessType = null;
      this.otherIndustry = null;
      this.otherBusinessModel = null;
      this.otherIndustrySearchResults = null;
      this.otherBusinessModelSearchResults = null;
    }
    _clearIndustrySelections() {
      this.isIndustryStepComplete = null;
      this.isBusinessModelStepComplete = null;
      this.selectedIndustry = null;
      this.selectedBusinessModel = null;
      this.selectedBusinessType = null;
      this.otherIndustry = null;
      this.otherBusinessModel = null;
      this.otherIndustrySearchResults = null;
      this.otherBusinessModelSearchResults = null;
    }
    _addOtherEntry(arr) {
      const otherIndustry = {
        name: 'Other',
        description: '',
        value: 'other'
      };
      return [...arr, otherIndustry];
    }
    _markIndustrySelectionComplete() {
      if (this.isIndustryFormComplete) {
        this.isIndustryStepComplete = true;
      } else {
        this.alerts.info(this.intl.t('alerts.profile_categorization.categorize_form.please_select_flash_message'), {});
      }
    }
    _markBusinessModelSelectionComplete() {
      if (this.isBusinessModelFormComplete) {
        this.isBusinessModelStepComplete = true;
        this._submitCategorizationInfo();
      } else {
        this.alerts.info(this.intl.t('alerts.profile_categorization.categorize_form.please_select_flash_message'));
      }
    }
    _submitCategorizationInfo() {
      this.args.submitCategorizationInfo(this.selectedCategory, this.selectedIndustry, this.selectedBusinessModel, this.otherIndustry, this.otherBusinessModel, (this.selectedIndustry || {}).keyword, (this.selectedBusinessModel || {}).keyword, this.selectedBusinessType);
    }

    /**
     * Handles keyup events:
     *
     * The Escape key calls `_markIndustrySelectionComplete`
     * and `_markBusinessModelSelectionComplete` which submits
     * the selected industry information.
     *
     * The Tab key: closes the ember drop if within one.
     *
     * @method _keyHandler
     * @protected
     */
    _keyHandler(event) {
      const key = event.key || event.keyCode;
      const industrySearchElement = document.getElementById('industry-search-box');
      const businessSearchElement = document.getElementById('business-search-box');
      const isInsideIndustryDrop = industrySearchElement && industrySearchElement.contains(event.target);
      const isInsideBusinessDrop = businessSearchElement && businessSearchElement.contains(event.target);
      const isInsideDrop = !!(isInsideIndustryDrop || isInsideBusinessDrop);
      if (key === 'Enter' || key === RETURN_KEY) {
        event.preventDefault();
        this._markIndustrySelectionComplete();
        this._markBusinessModelSelectionComplete();
      } else if ((key === 'Tab' || key === TAB_KEY) && isInsideDrop) {
        this.closeEmberDropActionIndustry(this.emberDropInstanceIndustry);
        this.closeEmberDropActionBusiness(this.emberDropInstanceBusiness);
      }
    }
    _searchOther(otherValue, values) {
      const lowercaseQuery = otherValue ? otherValue.toLowerCase() : otherValue;
      if (lowercaseQuery) {
        const otherSearchResults = (0, _search.computeSearchResults)(values, lowercaseQuery);
        const sortedSearchResults = (0, _search.sortSearchResultsByMatchRatio)(otherSearchResults);
        return (0, _utils.isEmpty)(sortedSearchResults) ? null : (0, _objectMethods.filterDistinctObjects)(sortedSearchResults);
      }
      return null;
    }
    _createObjForEachKeyword(objs) {
      const flattenedObjs = [];
      objs.forEach(obj => {
        (obj || {}).keywords.forEach(keyword => {
          const objWithKeyword = {
            ...obj,
            ...{
              keyword
            }
          };
          flattenedObjs.push(objWithKeyword);
        });
      });
      return flattenedObjs;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isCategoryStepComplete", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isIndustryStepComplete", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isBusinessModelStepComplete", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isBusinessTypeStepComplete", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "removedBusinessModelArrays", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "otherIndustrySearchResults", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "otherIndustry", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "otherBusinessModelSearchResults", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "otherBusinessModel", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "selectedCategory", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "selectedIndustry", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "selectedBusinessModel", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "selectedBusinessType", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "addKeyupListener", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addKeyupListener"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeKeyupListener", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeKeyupListener"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeBusinessModels", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeBusinessModels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "undoLastRemovedBusinessModels", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "undoLastRemovedBusinessModels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setOpenAction", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setOpenAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCloseAction", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setCloseAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchOtherIndustry", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "searchOtherIndustry"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchOtherBusinessModel", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "searchOtherBusinessModel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "chooseCategory", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "chooseCategory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "chooseIndustry", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "chooseIndustry"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "chooseBusinessType", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "chooseBusinessType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "chooseBusinessModel", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "chooseBusinessModel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackRedidCategorization", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackRedidCategorization"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearSelectedCategory", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearSelectedCategory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearSelectedIndustry", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearSelectedIndustry"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "markIndustrySelectionComplete", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "markIndustrySelectionComplete"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "markBusinessModelSelectionComplete", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "markBusinessModelSelectionComplete"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CategorizeStepsComponent);
});